<template>
	<h1>This is Alert</h1>
</template>

<script>
export default {

}
</script>